import 'components/FastTrackResultCard/_fastTrackResultCard.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import i18n from 'i18n-react';

export interface FastTrackResultCardProps {
  grade: string;
  passed: boolean;
  correctAnswers: number;
  totalQuestions: number;
  hasAchievements?: boolean;
  diplomaUrl?: string;
  onComplete?: (redirectTo?: string) => void;
}

export function FastTrackResultCard({ grade, passed, correctAnswers, totalQuestions, hasAchievements = false, diplomaUrl, onComplete }: FastTrackResultCardProps) {

  return (
    <div className="ft-result-card">
      <div className={clsx('ft-result-card__icon-circle', passed ? 'ft-result-card__icon-circle--success' : 'ft-result-card__icon-circle--failed')}>
        <FontAwesomeIcon icon={passed ? ['far', 'trophy'] : ['far', 'file-xmark']} />
      </div>
      <p className="ft-result-card__heading">
        {passed ? i18n.translate('FastTrackView.fastTrackComplete') : i18n.translate('FastTrackView.fastTrackNotPassed')}
      </p>
      <p className={clsx('ft-result-card__grade', passed ? 'ft-result-card__grade--success' : 'ft-result-card__grade--failed')}>{grade}</p>
      <p className="ft-result-card__grade-label">{i18n.translate('FastTrackView.gradeEarned')}</p>
      <div className={clsx('ft-result-card__stat-box', passed ? 'ft-result-card__stat-box--success' : 'ft-result-card__stat-box--failed')}>
        <FontAwesomeIcon
          icon={passed ? ['far', 'circle-check'] : ['fas', 'xmark']}
          className="ft-result-card__stat-icon"
        />
        <p className="ft-result-card__stat-fraction">
          {correctAnswers}
          {'/'}
          {totalQuestions}
        </p>
        <p className="ft-result-card__stat-label">{i18n.translate('FastTrackView.correct')}</p>
      </div>
      <p className="ft-result-card__message">
        {passed ? (
          <>
            {i18n.translate('FastTrackView.resultSuccessMessage')}
            {hasAchievements && (
              <>
                {i18n.translate('FastTrackView.resultAchievementsPrefix')}
                <a
                  href="/main/rewards/achievements"
                  className="ft-result-card__message-link"
                  onClick={(e) => {
                    e.preventDefault();
                    onComplete?.('/main/rewards/achievements');
                  }}
                >
                  {i18n.translate('FastTrackView.resultAchievementsLinkText')}
                </a>
                {i18n.translate('FastTrackView.resultAchievementsSuffix')}
              </>
            )}
          </>
        ) : (
          i18n.translate('FastTrackView.resultFailureMessage')
        )}
      </p>
      {diplomaUrl && (
        <a
          href={diplomaUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="ft-result-card__download-btn"
        >
          <FontAwesomeIcon icon={['fas', 'download']} />
          {i18n.translate('FastTrackView.downloadDiploma')}
        </a>
      )}
    </div>
  );
}
